import React from 'react';

import { AnimatedCircularProgressBar } from '@/Components/shadcn/animated-circular-progress-bar';
import { TypographyH3, TypographyP } from '@/Components/shadcn/typography';
import UIStrings from '@/Utils/UIStrings';
import { useCandidatesResultsContext } from '../../../Contexts/CandidateResultsContext';

const ExperienceScore = () => {
    const { results } = useCandidatesResultsContext();

    return (
        <div className="flex flex-col items-center gap-2.5 text-center">
            <TypographyH3 className="text-foreground text-2xl">{UIStrings.ExperienceScore}</TypographyH3>
            <TypographyP className="text-foreground max-w-3xl">
                {UIStrings.TheExperienceScoreShowsHowWellTheCandidateSResumeMatchesTheJobRequirements}
            </TypographyP>
            <div className="py-5">
                <AnimatedCircularProgressBar
                    value={results.experienceCriteriaScore?.averageExperienceCriteriaScore?.score}
                    level={results.experienceCriteriaScore?.averageExperienceCriteriaScore?.scoreLevel}
                    text={UIStrings.OverallScore}
                    className="size-50"
                />
            </div>
        </div>
    );
};

export default ExperienceScore;
